import ModuleWrapper from 'shared-lib/containers/Module';

const TrafficFiltering = () => import(/* webpackChunkName: "traffic-filtering" */ '@/views/trafficFiltering/TrafficFiltering');
const meta = (data = {}) => ({
    privilegeModule: 'traffic_filtering',
    permission: 'read',
    auth: true,
    ...data,
});

export default [{
    path: 'traffic-filtering',
    component: ModuleWrapper,
    meta: meta({
        title: 'Traffic Filtering',
    }),
    children: [
        {
            path: '',
            name: 'Traffic Filtering',
            component: TrafficFiltering,
            meta: meta(),
        },
    ],
}];
